// src/app/core/permissions/permission-normalizer.ts
export type RawPermission = string;          // "list users"
export type NormalizedPermission = string;   // "user.list"

const ACTION_MAP: Record<string, string> = {
  list: 'list',
  show: 'show',
  store: 'store',
  update: 'update',
  delete: 'delete',
};

const RESOURCE_MAP: Record<string, string> = {
  // الجمع → المفرد + دعم المفرد كما هو
  users: 'user',
  user: 'user',

  roles: 'role',
  role: 'role',

  services: 'service',
  service: 'service',

  contents: 'content',
  content: 'content',

  business: 'business', // بالفعل مفرد في اللستة

  // extra screens (raw strings زي ما بترجع من الـ API بعد lowerCase)
  'activity logs': 'activity-logs',
  'blocked subs': 'blocked-subs',
  'blocked subscribers': 'blocked-subs',
  'reports': 'reports',
  'report': 'reports',
  'customer support': 'customer-support',
};

export function normalizeOne(raw: RawPermission): NormalizedPermission | null {
  if (!raw) return null;
  const parts = raw.trim().toLowerCase().split(/\s+/); // ex: ["list","users"]
  const action = ACTION_MAP[parts[0]];
  const resourceRaw = parts.slice(1).join(' ');        // يدعم موارد من كلمتين لو ظهرت مستقبلًا
  const resource = RESOURCE_MAP[resourceRaw];

  if (!action || !resource) return null;
  return `${resource}.${action}`;
}

export function normalizeAll(rawPerms: RawPermission[]): NormalizedPermission[] {
  return (rawPerms ?? [])
    .map(normalizeOne)
    .filter((x): x is NormalizedPermission => !!x);
}
